import { render, staticRenderFns } from "./ModalVisualizarInformacaoTerritorioMonitoramento.vue?vue&type=template&id=3f9ac27d&lang=pug"
import script from "./ModalVisualizarInformacaoTerritorioMonitoramento.vue?vue&type=script&lang=js"
export * from "./ModalVisualizarInformacaoTerritorioMonitoramento.vue?vue&type=script&lang=js"
import style0 from "./ModalVisualizarInformacaoTerritorioMonitoramento.vue?vue&type=style&index=0&id=3f9ac27d&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports